import { render, staticRenderFns } from "./AppPublicLayout.vue?vue&type=template&id=0a356356&scoped=true&"
import script from "./AppPublicLayout.vue?vue&type=script&lang=ts&"
export * from "./AppPublicLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AppPublicLayout.vue?vue&type=style&index=0&id=0a356356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a356356",
  null
  
)

export default component.exports